<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="row" @click="targetWalletDraftState.target_wallet = item">
      <sb-checkbox :checked="targetWalletDraftState.target_wallet === item" :data-cy="`target-wallet-${item.replace(/\s+/g, '-')}-input`" /> {{ item }}
    </div>
  </div>
</template>

<script>
const items = [
  'referral',
  'interests',
  'birthday',
  'profile',
  'home',
  'shop online'
]

export default {
  props: {
    targetWalletDraftState: Object
  },

  name: "target-wallet-form",

  data() {
    return {
      items
    }
  }
}
</script>